import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
export interface ListQuery {
  order?: string,
  adv_id?: number,
  timezone?: string,
  module?: string,
  time?: string[],
  invoice_name?: string,
  company_name?: string,
  address?: string,
  bd_id?: number,
  bd_team_id?: number,
  bd_am_id?: number,
  bd_am_team_id?: number,
  pm_adv_id?: number,
  pm_adv_team_id?: number
}
/**
 * 投放渠道
 * @param {*} params
 */
export function fetchBillList(params: ListQuery) {
  return request({
    url: `${v2Host}/finance/bill/list`,
    method: 'get',
    params: cookRequestParams(params)
  })
}
export function exportBillList(params: ListQuery) {
  return request({
    url: `${v2Host}/finance/bill/export`,
    method: 'get',
    params: cookRequestParams(params)
  })
}
export function pushFinanceBill(data: {
  id: number
}) {
  return request({
    url: `${v2Host}/finance/bill/push`,
    method: 'post',
    data
  })
}

export function billRenewal(data: {
  id: number
}) {
  return request({
    url: `${v2Host}/finance/bill/renewal`,
    method: 'post',
    data
  })
}
